import { ActionCreatorProps, createAction, createActionGroup, Creator, emptyProps, props } from "@ngrx/store";
import { Vector2, Vector3 } from "three";
import { createInstanceActionGroup } from "../../../instance-service/state-utils/instanceActionGroup";

export const timerActions = (entityId: string) => {
  return createInstanceActionGroup({
    source: `Timer`,
    instanceId: entityId,
    events: {
      "Set name": props<{ name: String }>(),
      "Increment Seconds": emptyProps(),
      "Decrement Seconds": emptyProps(),
      "Increment Minutes": emptyProps(),
      "Decrement Minutes": emptyProps(),
      "Start": emptyProps(),
      "Stop": emptyProps(),
      "Reset": emptyProps(),
      "Tick": emptyProps(),
    }
  })
}

// type postActions = ReturnType<typeof postActions>

// const instanceTest = createInstanceActionGroup({
//   source: 'post',
//   instanceId: '123',
//   events: {
//     "Move": props<{ target: Vector3 }>(),
//     "Rewind Target": emptyProps(),
//   }
// })
//
//
